module.exports = __webpack_public_path__ + "img/arrow-up.b3389d56.svg";